import { BehaviorSubject } from 'rxjs';

export const dataFlow = new BehaviorSubject('data');
export const contentFlow = new BehaviorSubject("<!--Happy Coding-->");